import React from 'react';
import { Check, Shield, CreditCard, Download, Star, ArrowRight, AlertTriangle, BookOpen, Scale, Gavel, Users, Globe, FileText } from 'lucide-react';
import { CountdownTimer } from '../components/CountdownTimer';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { MetaPixel } from '../components/MetaPixel';
export function SalesPage() {
  const mainProductImage = 'https://cdn.magicpatterns.com/uploads/cpp14o8xdeCLgcZ9w8NDMH/upsell_derecho_(1).png';
  const bonus1Image = 'https://cdn.magicpatterns.com/uploads/8YViaSGQYBcmgFwwLmtPTA/bonus_1_(2).png';
  const bonus2Image = 'https://cdn.magicpatterns.com/uploads/f92t2HZ3ULEJgRYD7U9p1v/bonus_2_(2).png';
  const upsellImage = 'https://cdn.magicpatterns.com/uploads/g88my5ADUdP5T3BBdy8Xxr/upsell_derecho_.png';
  const MAIN_CHECKOUT_URL = 'https://pagos.docentesfelices.online/cart/50917997904178:1';
  const UPSELL_CHECKOUT_URL = 'https://pagos.docentesfelices.online/cart/50918002098482:1';
  const scrollToCheckout = () => {
    window.location.href = MAIN_CHECKOUT_URL;
  };
  const scrollToOffer = () => {
    const el = document.getElementById('oferta');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-gray-50 font-sans text-gray-900" data-id="element-19">
      <MetaPixel data-id="element-20" />
      <CountdownTimer data-id="element-21" />
      <SocialProofPopup data-id="element-22" />

      {/* HEADER / HERO SECTION */}
      <header className="bg-white pt-3 pb-4 px-4 sm:px-6 lg:px-8 text-center border-b border-gray-200" data-id="element-23">
        <div className="max-w-3xl mx-auto" data-id="element-24">
          <p className="bg-blue-600 text-white font-black tracking-wide uppercase mb-2 text-xs py-1 px-3 inline-block rounded" data-id="element-25">
            PARA DOCENTES DE DERECHO EN SECUNDARIA
          </p>

          <h1 className="text-2xl sm:text-3xl md:text-4xl font-black text-gray-900 leading-tight mb-2" data-id="element-26">
            Resolvé todo tu año de Derecho en un solo lugar y dejá de empezar
            desde cero con el{' '}
            <span className="text-green-600" data-id="element-27">MEGA PACK DERECHO LISTO</span>
          </h1>

          <div className="mb-2 flex justify-center" data-id="element-28">
            <img src={mainProductImage} alt="Mega Pack Derecho Listo Bundle" className="w-full max-w-lg drop-shadow-2xl cursor-pointer" onClick={scrollToCheckout} data-id="element-29" />
          </div>

          <p className="text-base sm:text-lg text-gray-600 mb-3 max-w-2xl mx-auto" data-id="element-30">
            Sistema integral de clases, secuencias, actividades, proyectos y
            recursos organizados por áreas del Derecho.
          </p>

          <div className="flex flex-wrap justify-center gap-2 sm:gap-4 text-sm font-bold text-gray-800 mb-3" data-id="element-31">
            <span className="flex items-center gap-1" data-id="element-32">
              <Check size={14} className="text-green-600" data-id="element-33" /> Todo el contenido
              estructurado
            </span>
            <span className="flex items-center gap-1" data-id="element-34">
              <Check size={14} className="text-green-600" data-id="element-35" /> Todo el material
              listo para usar
            </span>
            <span className="flex items-center gap-1" data-id="element-36">
              <Check size={14} className="text-green-600" data-id="element-37" /> Sin improvisar
            </span>
            <span className="flex items-center gap-1" data-id="element-38">
              <Check size={14} className="text-green-600" data-id="element-39" /> Sin armar desde
              cero
            </span>
          </div>

          <div className="mt-3" data-id="element-40">
            <button onClick={scrollToOffer} className="w-full bg-green-600 hover:bg-green-500 text-white text-base font-black py-3 px-4 rounded-lg shadow-[0_4px_0_rgb(21,128,61)] active:shadow-none active:translate-y-1 transition-all flex items-center justify-center gap-2 mx-auto" data-id="element-41">
              👉 SÍ, QUIERO ACCESO INMEDIATO
            </button>

            <div className="flex flex-wrap justify-center gap-3 mt-2 text-xs text-gray-500 font-medium" data-id="element-42">
              <span className="flex items-center gap-1" data-id="element-43">
                <Shield size={14} data-id="element-44" /> Pago seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-45">
                <Download size={14} data-id="element-46" /> Descarga inmediata
              </span>
              <span className="flex items-center gap-1" data-id="element-47">
                <Star size={14} data-id="element-48" /> Garantía 7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-49">
                <Check size={14} data-id="element-50" /> Acceso de por vida
              </span>
            </div>
          </div>
        </div>
      </header>

      {/* PROBLEM AWARENESS */}
      <section className="py-8 px-4 bg-gray-100" data-id="element-51">
        <div className="max-w-3xl mx-auto" data-id="element-52">
          <h2 className="text-2xl font-black text-center text-gray-900 mb-6 uppercase" data-id="element-53">
            SI SOS DOCENTE DE DERECHO, ESTO TE VA A SONAR FAMILIAR…
          </h2>

          <div className="bg-white p-6 rounded-xl shadow-md space-y-4 text-base text-gray-700" data-id="element-54">
            <p className="font-semibold text-lg" data-id="element-55">
              Llegás del colegio agotado/a… y todavía tenés que planificar.
            </p>

            <p data-id="element-56">Horas preparando clases sobre:</p>

            <ul className="grid grid-cols-2 gap-2 pl-2" data-id="element-57">
              {['Constitución Nacional', 'División de poderes', 'Derecho Civil', 'Derecho Penal', 'Derecho Laboral', 'Derechos Humanos', 'Ciudadanía y participación', 'Estado y sistema jurídico'].map(item => <li key={item} className="flex items-center gap-2 text-green-700 font-medium text-sm" data-id="element-58">
                  <AlertTriangle size={14} className="text-green-600 shrink-0" data-id="element-59" />{' '}
                  {item}
                </li>)}
            </ul>

            <div className="border-l-4 border-green-500 pl-4 italic text-gray-600 space-y-1 text-sm" data-id="element-60">
              <p data-id="element-61">Buscando casos reales para analizar.</p>
              <p data-id="element-62">Intentando que la materia no quede solo en teoría.</p>
              <p data-id="element-63">Armando evaluaciones claras y coherentes.</p>
            </div>

            <p className="font-bold text-lg text-center pt-2" data-id="element-64">
              No es falta de capacidad. <br data-id="element-65" />
              <span className="text-green-600" data-id="element-66">
                Es que te falta un sistema completo que te sostenga todo el año.
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* THE SOLUTION */}
      <section className="py-8 px-4 bg-white" data-id="element-67">
        <div className="max-w-4xl mx-auto text-center" data-id="element-68">
          <p className="text-green-600 font-bold tracking-widest uppercase mb-1 text-sm" data-id="element-69">
            LA SOLUCIÓN
          </p>
          <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-3" data-id="element-70">
            ⚖️ MEGA PACK DERECHO LISTO
          </h2>
          <p className="text-base text-gray-600 mb-6" data-id="element-71">
            Un sistema profesional de enseñanza del Derecho diseñado
            específicamente para secundaria.
          </p>

          <div className="flex flex-wrap justify-center gap-2 mb-8" data-id="element-72">
            {['Listo', 'Organizado', 'Aplicable', 'Adaptable', 'Profesional'].map(tag => <span key={tag} className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full font-bold flex items-center gap-1 text-sm" data-id="element-73">
                <Check size={14} data-id="element-74" /> {tag}
              </span>)}
          </div>
        </div>

        {/* MODULES GRID */}
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-75">
          {/* Module 1 */}
          <div className="bg-gray-50 rounded-xl p-4 border border-gray-200" data-id="element-76">
            <div className="bg-blue-600 text-white w-9 h-9 rounded-lg flex items-center justify-center mb-3" data-id="element-77">
              <Scale size={18} data-id="element-78" />
            </div>
            <h3 className="text-base font-bold text-gray-900 mb-3" data-id="element-79">
              ⚖️ DERECHO CONSTITUCIONAL
            </h3>
            <ul className="space-y-1 text-gray-600 text-xs" data-id="element-80">
              {['Constitución Nacional Argentina', 'Supremacía constitucional', 'Derechos y garantías', 'División de poderes', 'Control de constitucionalidad', 'Reforma constitucional', 'Ciudadanía y sistema republicano', 'Actividades de análisis constitucional'].map(i => <li key={i} className="flex items-start gap-1" data-id="element-81">
                  <Check size={12} className="mt-0.5 text-blue-500 shrink-0" data-id="element-82" />{' '}
                  {i}
                </li>)}
            </ul>
          </div>

          {/* Module 2 */}
          <div className="bg-gray-50 rounded-xl p-4 border border-gray-200" data-id="element-83">
            <div className="bg-red-600 text-white w-9 h-9 rounded-lg flex items-center justify-center mb-3" data-id="element-84">
              <Gavel size={18} data-id="element-85" />
            </div>
            <h3 className="text-base font-bold text-gray-900 mb-3" data-id="element-86">
              ⚖️ DERECHO PENAL
            </h3>
            <ul className="space-y-1 text-gray-600 text-xs" data-id="element-87">
              {['Concepto de delito', 'Tipos penales', 'Responsabilidad penal', 'Garantías procesales', 'Sistema penal argentino', 'Casos prácticos', 'Análisis de situaciones reales', 'Debates guiados'].map(i => <li key={i} className="flex items-start gap-1" data-id="element-88">
                  <Check size={12} className="mt-0.5 text-red-500 shrink-0" data-id="element-89" />{' '}
                  {i}
                </li>)}
            </ul>
          </div>

          {/* Module 3 */}
          <div className="bg-gray-50 rounded-xl p-4 border border-gray-200" data-id="element-90">
            <div className="bg-purple-600 text-white w-9 h-9 rounded-lg flex items-center justify-center mb-3" data-id="element-91">
              <Users size={18} data-id="element-92" />
            </div>
            <h3 className="text-base font-bold text-gray-900 mb-3" data-id="element-93">
              ⚖️ DERECHO CIVIL
            </h3>
            <ul className="space-y-1 text-gray-600 text-xs" data-id="element-94">
              {['Personas físicas y jurídicas', 'Capacidad', 'Contratos', 'Obligaciones', 'Responsabilidad civil', 'Derechos reales', 'Actividades prácticas'].map(i => <li key={i} className="flex items-start gap-1" data-id="element-95">
                  <Check size={12} className="mt-0.5 text-purple-500 shrink-0" data-id="element-96" />{' '}
                  {i}
                </li>)}
            </ul>
          </div>

          {/* Module 4 */}
          <div className="bg-gray-50 rounded-xl p-4 border border-gray-200" data-id="element-97">
            <div className="bg-orange-600 text-white w-9 h-9 rounded-lg flex items-center justify-center mb-3" data-id="element-98">
              <BriefcaseIcon data-id="element-99" />
            </div>
            <h3 className="text-base font-bold text-gray-900 mb-3" data-id="element-100">
              ⚖️ DERECHO LABORAL
            </h3>
            <ul className="space-y-1 text-gray-600 text-xs" data-id="element-101">
              {['Derechos del trabajador', 'Contrato de trabajo', 'Jornada laboral', 'Salario', 'Sindicatos', 'Conflictos laborales', 'Casos prácticos'].map(i => <li key={i} className="flex items-start gap-1" data-id="element-102">
                  <Check size={12} className="mt-0.5 text-orange-500 shrink-0" data-id="element-103" />{' '}
                  {i}
                </li>)}
            </ul>
          </div>

          {/* Module 5 */}
          <div className="bg-gray-50 rounded-xl p-4 border border-gray-200" data-id="element-104">
            <div className="bg-teal-600 text-white w-9 h-9 rounded-lg flex items-center justify-center mb-3" data-id="element-105">
              <Globe size={18} data-id="element-106" />
            </div>
            <h3 className="text-base font-bold text-gray-900 mb-3" data-id="element-107">
              ⚖️ DERECHOS HUMANOS
            </h3>
            <ul className="space-y-1 text-gray-600 text-xs" data-id="element-108">
              {['Declaración Universal', 'Sistema interamericano', 'Derechos civiles, sociales y políticos', 'Igualdad y no discriminación', 'Jurisprudencia aplicada', 'Análisis crítico'].map(i => <li key={i} className="flex items-start gap-1" data-id="element-109">
                  <Check size={12} className="mt-0.5 text-teal-500 shrink-0" data-id="element-110" />{' '}
                  {i}
                </li>)}
            </ul>
          </div>

          {/* Module 6 */}
          <div className="bg-gray-50 rounded-xl p-4 border border-gray-200" data-id="element-111">
            <div className="bg-indigo-600 text-white w-9 h-9 rounded-lg flex items-center justify-center mb-3" data-id="element-112">
              <Globe size={18} data-id="element-113" />
            </div>
            <h3 className="text-base font-bold text-gray-900 mb-3" data-id="element-114">
              ⚖️ DERECHO INTERNACIONAL
            </h3>
            <ul className="space-y-1 text-gray-600 text-xs" data-id="element-115">
              {['Organismos internacionales', 'Tratados', 'Derechos humanos en el mundo', 'Globalización y Derecho', 'Responsabilidad internacional'].map(i => <li key={i} className="flex items-start gap-1" data-id="element-116">
                  <Check size={12} className="mt-0.5 text-indigo-500 shrink-0" data-id="element-117" />{' '}
                  {i}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="max-w-4xl mx-auto mt-6 bg-blue-50 p-4 rounded-xl text-center border border-blue-200" data-id="element-118">
          <h4 className="text-sm font-bold text-blue-900 mb-3" data-id="element-119">
            Cada módulo incluye:
          </h4>
          <div className="flex flex-wrap justify-center gap-3 text-xs font-medium text-blue-800" data-id="element-120">
            {['Desarrollo conceptual claro', 'Casos reales para análisis', 'Actividades listas para usar', 'Consignas de debate', 'Trabajos prácticos', 'Recursos didácticos', 'Material editable'].map(i => <span key={i} className="flex items-center gap-1" data-id="element-121">
                <Check size={12} data-id="element-122" /> {i}
              </span>)}
          </div>
        </div>
      </section>

      {/* RESULTS / TRANSFORMATION */}
      <section className="py-8 px-4 bg-gray-900 text-white" data-id="element-123">
        <div className="max-w-5xl mx-auto" data-id="element-124">
          <h2 className="text-2xl sm:text-3xl font-black text-center mb-6 text-yellow-400" data-id="element-125">
            RESULTADOS QUE TRANSFORMAN
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-126">
            <div data-id="element-127">
              <h3 className="text-lg font-bold mb-3 flex items-center gap-2" data-id="element-128">
                <span className="bg-yellow-500 text-black w-7 h-7 rounded-full flex items-center justify-center text-xs" data-id="element-129">
                  1
                </span>
                Para tus estudiantes
              </h3>
              <ul className="space-y-2 text-sm" data-id="element-130">
                {['Analizan casos reales', 'Debaten con fundamentos jurídicos', 'Comprenden el sistema legal', 'Conectan el Derecho con la realidad', 'Participan activamente'].map(i => <li key={i} className="flex items-center gap-2" data-id="element-131">
                    <Check size={14} className="text-green-400 shrink-0" data-id="element-132" /> {i}
                  </li>)}
              </ul>
            </div>
            <div data-id="element-133">
              <h3 className="text-lg font-bold mb-3 flex items-center gap-2" data-id="element-134">
                <span className="bg-yellow-500 text-black w-7 h-7 rounded-full flex items-center justify-center text-xs" data-id="element-135">
                  2
                </span>
                Para vos como docente
              </h3>
              <ul className="space-y-2 text-sm" data-id="element-136">
                {['Ahorrás horas de planificación', 'Tenés seguridad conceptual', 'Tenés todo organizado por áreas', 'Dejás de improvisar', 'Recuperás tiempo personal'].map(i => <li key={i} className="flex items-center gap-2" data-id="element-137">
                    <Check size={14} className="text-green-400 shrink-0" data-id="element-138" /> {i}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="mt-6 text-center" data-id="element-139"></div>
        </div>
      </section>

      {/* BONUSES */}
      <section className="py-8 px-4 bg-white" data-id="element-140">
        <div className="max-w-5xl mx-auto" data-id="element-141">
          <h2 className="text-2xl sm:text-3xl font-black text-center text-green-600 mb-6 uppercase border-b-4 border-green-600 pb-2" data-id="element-142">
            🎁 BONOS EXCLUSIVOS INCLUIDOS HOY
          </h2>

          {/* Bonus 1 */}
          <div className="flex flex-col md:flex-row items-center gap-6 mb-8 border-b border-gray-200 pb-8" data-id="element-143">
            <div className="w-full md:w-1/2 flex justify-center" data-id="element-144">
              <img src={bonus1Image} alt="Bono 1 Planificación Anual" className="w-full max-w-sm drop-shadow-xl cursor-pointer" onClick={scrollToCheckout} data-id="element-145" />
            </div>
            <div className="w-full md:w-1/2" data-id="element-146">
              <span className="bg-green-600 text-white px-3 py-1 rounded text-xs font-bold mb-2 inline-block" data-id="element-147">
                BONO 1 – GRATIS HOY
              </span>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-148">
                PLANIFICACIÓN ANUAL DERECHO LISTA
              </h3>
              <ul className="space-y-2 text-gray-700 text-sm" data-id="element-149">
                {['Objetivos claros', 'Fundamentación jurídica', 'Organización por unidades', 'Cronograma anual', 'Lista para presentar'].map(i => <li key={i} className="flex items-center gap-2" data-id="element-150">
                    <Check size={14} className="text-green-600" data-id="element-151" /> {i}
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="flex flex-col md:flex-row-reverse items-center gap-6" data-id="element-152">
            <div className="w-full md:w-1/2 flex justify-center" data-id="element-153">
              <img src={bonus2Image} alt="Bono 2 Maletín de Actividades" className="w-full max-w-sm drop-shadow-xl cursor-pointer" onClick={scrollToCheckout} data-id="element-154" />
            </div>
            <div className="w-full md:w-1/2" data-id="element-155">
              <span className="bg-green-600 text-white px-3 py-1 rounded text-xs font-bold mb-2 inline-block" data-id="element-156">
                BONO 2 – GRATIS HOY
              </span>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-157">
                MALETÍN DE ACTIVIDADES DE DERECHO
              </h3>
              <p className="mb-3 font-semibold text-gray-600 text-sm" data-id="element-158">
                Decenas de recursos listos:
              </p>
              <ul className="space-y-2 text-gray-700 text-sm" data-id="element-159">
                {['Estudios de caso reales', 'Simulaciones judiciales', 'Debates estructurados', 'Análisis de noticias jurídicas', 'Actividades grupales', 'Proyectos integradores'].map(i => <li key={i} className="flex items-center gap-2" data-id="element-160">
                    <Check size={14} className="text-green-600" data-id="element-161" /> {i}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* OFFER SECTION */}
      <section id="oferta" className="py-8 px-4 bg-gray-50 border-t border-gray-200" data-id="element-162">
        <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-2xl overflow-hidden border-2 border-yellow-400" data-id="element-163">
          <div className="bg-green-600 text-white text-center py-3 px-4" data-id="element-164">
            <h2 className="text-xl sm:text-2xl font-black uppercase" data-id="element-165">
              🔥 OFERTA ESPECIAL POR TIEMPO LIMITADO
            </h2>
          </div>

          <div className="p-6 text-center" data-id="element-166">
            <h3 className="text-2xl sm:text-3xl font-black text-gray-900 mb-2" data-id="element-167">
              MEGA PACK DERECHO LISTO
            </h3>

            <div className="flex flex-wrap justify-center gap-3 text-xs text-gray-600 mb-6" data-id="element-168">
              <span data-id="element-169">Acceso de por vida</span>
              <span data-id="element-170">•</span>
              <span data-id="element-171">Descarga inmediata</span>
              <span data-id="element-172">•</span>
              <span data-id="element-173">Garantía 7 días</span>
              <span data-id="element-174">•</span>
              <span data-id="element-175">2 Bonos incluidos</span>
            </div>

            <div className="mb-6" data-id="element-176">
              <p className="text-gray-500 text-base line-through mb-1" data-id="element-177">
                Precio regular $49.990 ARS
              </p>
              <div className="flex items-center justify-center gap-2" data-id="element-178">
                <span className="text-lg font-bold text-gray-700" data-id="element-179">HOY</span>
                <span className="text-4xl sm:text-5xl font-black text-green-600" data-id="element-180">
                  $19.990 ARS
                </span>
              </div>
            </div>

            <button onClick={scrollToCheckout} className="w-full bg-green-600 hover:bg-green-500 text-white text-sm sm:text-base lg:text-lg font-black py-5 px-4 rounded-lg shadow-[0_4px_0_rgb(21,128,61)] active:shadow-none active:translate-y-1 transition-all animate-pulse mb-4 whitespace-nowrap" data-id="element-181">
              👉 SÍ, QUIERO EL MEGA PACK – $19.990 ARS
            </button>

            <div className="flex flex-col items-center gap-1" data-id="element-182">
              <p className="text-xs text-gray-600 font-semibold" data-id="element-183">
                Métodos de pago seguros:
              </p>
              <div className="flex gap-3 text-gray-500 text-sm" data-id="element-184">
                <CreditCard size={18} data-id="element-185" />
                <span className="font-bold" data-id="element-186">Mercado Pago</span>
                <span className="font-bold" data-id="element-187">Visa</span>
                <span className="font-bold" data-id="element-188">Mastercard</span>
              </div>
              <p className="text-xs text-gray-400" data-id="element-189">
                Transferencia por WhatsApp disponible
              </p>
            </div>
          </div>

          <div className="bg-gray-100 p-4 border-t border-gray-200" data-id="element-190">
            <h4 className="font-bold text-gray-900 mb-3 text-center text-sm" data-id="element-191">
              🔽 ¿Cómo recibís el material?
            </h4>
            <div className="grid grid-cols-3 gap-3 text-xs text-gray-700" data-id="element-192">
              {[['1', 'Realizás la compra e ingresás tu correo.'], ['2', 'Finalizás el pago.'], ['3', 'Recibís automáticamente el link de descarga.']].map(([n, t]) => <div key={n} className="text-center" data-id="element-193">
                  <div className="bg-white w-7 h-7 rounded-full flex items-center justify-center font-bold border border-gray-300 mx-auto mb-1 text-xs" data-id="element-194">
                    {n}
                  </div>
                  <p data-id="element-195">{t}</p>
                </div>)}
            </div>
            <p className="text-center text-xs text-green-700 font-bold mt-3 uppercase" data-id="element-196">
              IMPORTANTE REVISAR SPAM DEL CORREO • ACCESO INMEDIATO
            </p>
          </div>
        </div>
      </section>

      {/* UPSELL SECTION */}
      <section className="py-8 px-4 bg-yellow-50 border-y-4 border-yellow-400" data-id="element-197">
        <div className="max-w-4xl mx-auto" data-id="element-198">
          <div className="text-center mb-5" data-id="element-199">
            <span className="bg-yellow-400 text-black px-4 py-1 rounded-full text-sm font-black uppercase tracking-wider inline-block mb-3" data-id="element-200">
              ⭐ MÁS POPULAR
            </span>
            <h2 className="text-2xl sm:text-3xl font-black text-gray-900" data-id="element-201">
              MEGA PACK DERECHO LISTO + SISTEMA PRO DE EVALUACIONES
            </h2>
          </div>

          <div className="flex flex-col md:flex-row items-center gap-6 bg-white p-5 rounded-xl shadow-lg" data-id="element-202">
            <div className="w-full md:w-1/3" data-id="element-203">
              <img src={upsellImage} alt="Sistema Pro de Evaluaciones" className="w-full rounded-lg shadow-md" data-id="element-204" />
            </div>
            <div className="w-full md:w-2/3" data-id="element-205">
              <h3 className="text-base font-bold text-gray-900 mb-3" data-id="element-206">
                ¿Qué incluye el SISTEMA PRO DE EVALUACIONES EN DERECHO?
              </h3>
              <ul className="grid grid-cols-2 gap-1 mb-4 text-xs text-gray-700" data-id="element-207">
                {['Banco profesional de evaluaciones', 'Evaluaciones por área temática', 'Rúbricas detalladas', 'Instrumentos de evaluación', 'Modelos de trabajos prácticos', 'Evaluaciones con análisis de casos', 'Criterios de corrección claros', 'Sistema completo para todo el ciclo'].map(i => <li key={i} className="flex items-center gap-1" data-id="element-208">
                    <Check size={12} className="text-green-600 shrink-0" data-id="element-209" /> {i}
                  </li>)}
              </ul>
              <p className="font-medium text-gray-600 mb-4 italic text-sm" data-id="element-210">
                Ideal para dejar de improvisar exámenes.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-gray-100 pt-4" data-id="element-211">
                <div data-id="element-212">
                  <p className="text-gray-500 line-through text-xs" data-id="element-213">
                    Precio regular $34.990 ARS
                  </p>
                  <span className="text-2xl font-black text-gray-900" data-id="element-214">
                    HOY $24.990 ARS
                  </span>
                  <br data-id="element-215" />
                  <span className="text-xs font-bold text-green-600 bg-green-100 px-2 py-0.5 rounded" data-id="element-216">
                    Ahorrás $10.000 ARS
                  </span>
                </div>
                <a href={UPSELL_CHECKOUT_URL} className="w-full sm:w-auto bg-green-600 hover:bg-green-500 text-white text-base font-black py-3 px-5 rounded-lg shadow-[0_4px_0_rgb(21,128,61)] active:shadow-none active:translate-y-1 transition-all text-center" data-id="element-217">
                  👉 SÍ, QUIERO EL SUPER PACK COMPLETO
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="py-8 px-4 bg-white" data-id="element-218">
        <div className="max-w-3xl mx-auto text-center border-4 border-dashed border-gray-300 p-6 rounded-2xl" data-id="element-219">
          <Shield className="w-12 h-12 text-green-600 mx-auto mb-3" data-id="element-220" />
          <h2 className="text-2xl font-black text-gray-900 mb-2" data-id="element-221">
            GARANTÍA TOTAL
          </h2>
          <p className="text-lg text-gray-700 mb-1" data-id="element-222">Probalo 7 días.</p>
          <p className="text-gray-600 mb-1" data-id="element-223">
            Si no cumple tus expectativas, te devolvemos el 100%.
          </p>
          <p className="font-bold text-gray-900 uppercase" data-id="element-224">Sin preguntas.</p>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-8 px-4 bg-gray-50" data-id="element-225">
        <div className="max-w-5xl mx-auto" data-id="element-226">
          <h2 className="text-2xl font-black text-center text-gray-900 mb-6" data-id="element-227">
            TESTIMONIOS DE DOCENTES
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-228">
            {[{
            q: '"Ahora tengo el Derecho organizado por áreas, no improviso más."',
            a: '– María L., Córdoba'
          }, {
            q: '"Los casos reales generan debates increíbles."',
            a: '– Fernando R., Buenos Aires'
          }, {
            q: '"El sistema está claro y profesional."',
            a: '– Carla P., Mendoza'
          }, {
            q: '"Me ahorró semanas de trabajo. El material de penal es excelente."',
            a: '– Roberto S., Santa Fe'
          }, {
            q: '"Mis alumnos por fin se engancharon con la materia. Muy recomendado."',
            a: '– Laura G., Neuquén'
          }].map(({
            q,
            a
          }) => <div key={a} className="bg-white p-4 rounded-xl shadow-md" data-id="element-229">
                <div className="flex text-yellow-400 mb-2" data-id="element-230">
                  {[1, 2, 3, 4, 5].map(n => <Star key={n} size={14} fill="currentColor" data-id="element-231" />)}
                </div>
                <p className="text-gray-700 italic mb-2 text-sm" data-id="element-232">{q}</p>
                <p className="font-bold text-gray-900 text-sm" data-id="element-233">{a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-10 px-4 bg-gray-900 text-white text-center" data-id="element-234">
        <div className="max-w-3xl mx-auto" data-id="element-235">
          <h2 className="text-2xl sm:text-3xl font-black mb-3" data-id="element-236">
            ¿LISTO/A PARA DEJAR DE IMPROVISAR?
          </h2>
          <p className="text-base text-gray-300 mb-6" data-id="element-237">
            Sumate a docentes que ya tienen su año resuelto.
          </p>
          <button onClick={scrollToCheckout} className="w-full sm:w-auto bg-green-600 hover:bg-green-500 text-white text-xl sm:text-2xl font-black py-5 px-10 rounded-lg shadow-[0_4px_0_rgb(21,128,61)] active:shadow-none active:translate-y-1 transition-all" data-id="element-238">
            👉 QUIERO EMPEZAR AHORA
          </button>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="py-5 bg-black text-gray-500 text-center text-xs" data-id="element-239">
        <div className="max-w-4xl mx-auto px-4" data-id="element-240">
          <p className="mb-2" data-id="element-241">© 2026 MEGA PACK DERECHO LISTO ™</p>
          <div className="flex justify-center gap-4" data-id="element-242">
            <span className="cursor-pointer hover:text-gray-300" data-id="element-243">Términos</span>
            <span data-id="element-244">–</span>
            <span className="cursor-pointer hover:text-gray-300" data-id="element-245">
              Privacidad
            </span>
            <span data-id="element-246">–</span>
            <span className="cursor-pointer hover:text-gray-300" data-id="element-247">Soporte</span>
          </div>
        </div>
      </footer>
    </div>;
}
function BriefcaseIcon() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-248">
      <rect width="20" height="14" x="2" y="7" rx="2" ry="2" data-id="element-249" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" data-id="element-250" />
    </svg>;
}